(() => {
  function select(gallery, index) {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    if (!slides.length) return;
    index = (index + slides.length) % slides.length;
    slides.forEach((slide,i) => {
      slide.hidden = i !== index;
      if (slide.hidden) slide.querySelectorAll('video').forEach(video => video.pause());
    });
    gallery.querySelectorAll('[data-gallery-thumbnail]').forEach(button => {
      const active = button.dataset.galleryThumbnail === slides[index].dataset.mediaId;
      button.setAttribute('aria-pressed',String(active));
      if (active) { const strip = button.parentElement; strip.scrollTo({left:button.offsetLeft-strip.offsetLeft-(strip.clientWidth-button.clientWidth)/2,behavior:'instant'}); }
    });
    gallery.querySelector('[data-gallery-status]').textContent = `Image ${index + 1} of ${slides.length}`;
  }
  function move(gallery, step) {
    const slides = [...gallery.querySelectorAll('[data-gallery-slide]')];
    select(gallery, Math.max(0,slides.findIndex(slide => !slide.hidden)) + step);
  }
  function quantityState(detail) {
    const input = detail?.querySelector('[name=quantity]');
    if (!input) return;
    const min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity;
    detail.querySelector('[data-quantity-step="-1"]')?.toggleAttribute('disabled', Number(input.value) <= min);
    detail.querySelector('[data-quantity-step="1"]')?.toggleAttribute('disabled', Number(input.value) >= max);
  }
  document.addEventListener('click', event => {
    const gallery = event.target.closest('[data-product-gallery]');
    const thumb = event.target.closest('[data-gallery-thumbnail]');
    const arrow = event.target.closest('[data-gallery-step]');
    if (gallery && thumb) select(gallery,[...gallery.querySelectorAll('[data-gallery-slide]')].findIndex(slide=>slide.dataset.mediaId===thumb.dataset.galleryThumbnail));
    if (gallery && arrow) move(gallery,Number(arrow.dataset.galleryStep));
    const step = event.target.closest('[data-quantity-step]');
    if (step) {
      const detail = step.closest('[data-product-detail]');
      const input = detail.querySelector('[name=quantity]');
      if (!input.value || !Number.isFinite(Number(input.value))) input.value = input.min || '1';
      Number(step.dataset.quantityStep) > 0 ? input.stepUp() : input.stepDown();
      input.dispatchEvent(new Event('change',{bubbles:true}));
      quantityState(detail);
    }
  });
  document.addEventListener('input',event=>{if(event.target.matches('[name=quantity]'))quantityState(event.target.closest('[data-product-detail]'));});
  document.addEventListener('change',event=>{
    const detail=event.target.closest('[data-product-detail]');
    if (!detail) return;
    quantityState(detail);
    if (event.target.matches('[data-variant-select]')) {
      const variant=JSON.parse(detail.querySelector('[data-variants]').textContent).find(v=>String(v.id)===event.target.value);
      const buyNow=detail.querySelector('[data-buy-now]'); if(buyNow) buyNow.disabled=!variant?.available;
      const gallery=detail.querySelector('[data-product-gallery]');
      const index=gallery && [...gallery.querySelectorAll('[data-gallery-slide]')].findIndex(s=>s.dataset.mediaId===String(variant?.mediaId));
      if(index>=0)select(gallery,index);
    }
  });
  document.addEventListener('keydown',event=>{
    const stage=event.target.closest('.product-gallery-stage');
    if(stage && event.target===stage && ['ArrowLeft','ArrowRight'].includes(event.key)) {event.preventDefault();move(stage.closest('[data-product-gallery]'),event.key==='ArrowLeft'?-1:1);}
  });
  let swipe;
  document.addEventListener('pointerdown',event=>{
    const gallery=event.target.closest('[data-product-gallery]');
    if(gallery && event.target.matches('.product-media img'))swipe={gallery,x:event.clientX,y:event.clientY};
  });
  document.addEventListener('pointerup',event=>{
    if(!swipe)return;
    const dx=event.clientX-swipe.x,dy=event.clientY-swipe.y;
    if(Math.abs(dx)>45 && Math.abs(dx)>Math.abs(dy))move(swipe.gallery,dx<0?1:-1);
    swipe=null;
  });
  document.addEventListener('pointercancel',()=>{swipe=null;});
  document.addEventListener('dragstart',event=>{if(event.target.matches('.product-media img'))event.preventDefault();});
})();
